import { register } from '@shopify/theme-sections';
import * as Cart from '@shopify/theme-cart';
import * as Helpers from '../utilities/helpers';
import '../components/cart-recommendations';
Avatar.theme = Avatar.theme || {};

Avatar.theme.Cart = function CartFn() {
  var selectors = {
    container: '[data-section-type="cart-template"]',
    cartTitle: '.cart-title',
    cartForm: '.cart-form',
    cartCount: '.cart-count',
    cartCountText: '.cart-count-text',
    cartTotal: '.cart-total',
    cartPrice: '.cart-price',
    cartPriceSubtotal: '[data-cart-price-subtotal]',
    cartPriceBreakdown: '[data-price-breakdown]',
    cartPriceLabel: '[data-cart-price-label]',
    cartItem: '.cart-item',
    cartItemQuantity: '.cart-item-quantity',
    cartItemQuantityStep: '.cart-item-quantity-step',
    cartItemQuantityInput: '.cart-item-quantity-input',
    cartItemPrice: '[data-cart-final-price]',
    cartItemPriceOriginal: '[data-cart-original-price]',
    cartItemDiscounts: '[data-cart-item-discount-amount]',
    cartDiscounts: '[data-cart-discount-applications]',
    cartItemRemove: '.cart-item-remove',
    linePrice: '[data-line-price]',
    linePriceDiscounted: '[data-line-price-discounted]'
  };
  var classes = {
    flex: 'tw-flex',
    hidden: 'tw-hidden',
    textRight: 'tw-text-right',
    textCenter: 'tw-text-center',
    widthLeft: 'tw-w-2/3',
    widthRight: 'tw-w-1/3',
    noCookies: 'no-cookies'
  };
  var data = {
    key: 'data-item-key'
  };
  var cache = {};

  function cacheDOM() {
    cache = {
      container: document.querySelector(selectors.container),
      cartTitle: document.querySelector(selectors.cartTitle),
      cartForm: document.querySelector(selectors.cartForm),
      cartCount: document.querySelectorAll(selectors.cartCount),
      cartCountText: document.querySelector(selectors.cartCountText),
      cartPrice: document.querySelector(selectors.cartPrice),
      cartItem: document.querySelectorAll(selectors.cartItem),
      cartItemQuantity: document.querySelectorAll(selectors.cartItemQuantity),
      cartItemPrice: document.querySelectorAll(selectors.cartItemPrice),
      cartItemRemove: document.querySelectorAll(selectors.cartItemRemove)
    };
  }

  function init() {
    cacheDOM();
    initCartForm();
    checkCookies();
  }

  function initCartForm() {
    cache.cartItemQuantity.forEach(function (quantity) {
      var cartItemQuantityStep = quantity.querySelectorAll(selectors.cartItemQuantityStep);
      var cartItemQuantityInput = quantity.querySelectorAll(selectors.cartItemQuantityInput);
      cartItemQuantityStep.forEach(function (step) {
        return step.addEventListener('click', handleQuantityClick);
      });
      cartItemQuantityInput.forEach(function (input) {
        return input.addEventListener('change', handleQuantityChange);
      });
    });
    cache.cartItemRemove.forEach(function (removeBtn) {
      return removeBtn.addEventListener('click', handleItemRemove);
    });
  }

  function handleQuantityClick(evt) {
    var currentTarget = evt.currentTarget;
    var quantityInput = currentTarget.parentElement.querySelector(selectors.cartItemQuantityInput);

    if (currentTarget.hasAttribute('data-step-up')) {
      quantityInput.stepUp();
    } else if (currentTarget.hasAttribute('data-step-down')) {
      quantityInput.stepDown();
    }

    setQuantityControls(quantityInput);
    var changeEvent = new Event('change');
    quantityInput.dispatchEvent(changeEvent);
  }

  function handleQuantityChange(evt) {
    var currentTarget = evt.currentTarget;
    var cartItem = evt.currentTarget.closest(selectors.cartItem);
    var key = cartItem.getAttribute(data.key);
    var quantity = setQuantityControls(currentTarget);

    if (quantity <= 0) {
      removeItem(cartItem);
      return;
    }

    Cart.updateItem(key, {
      quantity: quantity
    }).then(function (cart) {
      var item = cart.items.find(function (item) {
        return item.key.split(':')[0] === key.split(':')[0];
      });
      renderCount(cart.item_count);
      renderCartPrices(cart);
      renderLinePrice(item, cartItem, cart.cart_level_discount_applications);
      updateCartItemsKey(cart);
    });
  }

  function handleItemRemove(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    var currentTarget = evt.currentTarget;
    var cartItem = currentTarget.closest(selectors.cartItem);
    removeItem(cartItem);
  }
  /**
   * Removes item from cart
   *
   * @param object cartItem dom object
   * @return void
   */


  function removeItem(cartItem) {
    var key = cartItem.dataset.itemKey;
    Cart.removeItem(key).then(function (cart) {
      if (cart.item_count > 0) {
        cartItem.remove();
        renderCount(cart.item_count);
        renderCartPrices(cart);
        updateCartItemsKey(cart);
      } else {
        renderEmptyCart();
      }
    });
  }

  function updateCartItemsKey(cart) {
    var cartItems = document.querySelectorAll(selectors.cartItem);
    cart.items.forEach(function (item) {
      var variantId = item.key.split(':')[0];
      cartItems.forEach(function (cartItem) {
        var cartItemVariantId = cartItem.dataset.itemKey.split(':')[0];

        if (cartItemVariantId === variantId) {
          cartItem.dataset.itemKey = item.key;
        }
      });
    });
  }

  function renderCount(count) {
    cache.cartCount.forEach(function (countText) {
      var countTextEl = countText;
      countTextEl.textContent = count;
    });
    cache.cartCountText.textContent = Avatar.theme.i18n[count === 1 ? 'item' : 'items'];
  }

  function renderLinePrice(item, cartItem, cartDiscounts) {
    var currency = Avatar.theme.Currency;
    var quantityInput = cartItem.querySelector(selectors.cartItemQuantityInput);
    quantityInput.value = item.quantity;
    var prices = cartItem.querySelectorAll(selectors.cartItemPrice);
    prices.forEach(function (price) {
      return price.textContent = currency.formatMoney(item.final_line_price);
    });

    if (item.final_line_price !== item.original_line_price) {
      var priceOriginal = cartItem.querySelector(selectors.cartItemPriceOriginal);
      priceOriginal.textContent = currency.formatMoney(item.original_line_price);
    }

    var linePriceDiscounted = cartItem.querySelector(selectors.linePriceDiscounted);
    var linePriceContainer = cartItem.querySelector(selectors.linePrice); // Only show line item discount if there is not cart level discounts

    if (item.discounts.length > 0 && cartDiscounts.length <= 0) {
      linePriceDiscounted.classList.remove(classes.hidden);
      linePriceContainer.classList.add(classes.hidden);
    } else {
      linePriceDiscounted.classList.add(classes.hidden);
      linePriceContainer.classList.remove(classes.hidden);
    }

    renderItemDiscounts(item.discounts, cartItem);
  }

  function renderEmptyCart() {
    var emptyHtml = "\n      <p class=\"mb-5 text-center\">".concat(Avatar.theme.i18n.empty, "</p>\n      <a class=\"tw-btn tw-btn-primary rounded-pill font-600 tw-block tw-mx-auto tw-w-full md:tw-w-1/4\"\n          href=\"").concat(Avatar.theme.settings.cart.continueShopping, "\">\n          ").concat(Avatar.theme.i18n.continue, "\n      </a>\n    ");
    var htmlObject = document.createElement('div');
    htmlObject.innerHTML = emptyHtml;
    cache.cartTitle.after(htmlObject);
    cache.cartCount.forEach(function (count) {
      return count.remove();
    });
    cache.cartCountText.remove();
    cache.cartForm.remove();

    if (Avatar.theme.settings.cart.showRecsOnEmptyCart === false) {
      document.querySelector('.cart-recommendations').remove();
    }
  }
  /**
   * Renders discount allocations
   *
   * @param {array} discounts
   * @param {object} $cartItem
   */


  function renderItemDiscounts(discounts, cartItem) {
    // const cartItem = $cartItem[0];
    var discounstContainer = cartItem.querySelector(selectors.cartItemDiscounts);

    if (!discounstContainer) {
      return;
    }

    discounstContainer.innerHTML = '';
    discounts.forEach(function (discount) {
      discounstContainer.innerHTML += "\n        <div>\n          <i class=\"fa fa-tags\"></i> ".concat(discount.title, "\n          (-<span>").concat(Avatar.theme.Currency.formatMoney(discount.amount), "</span>)\n        <div>\n      ");
    });
  }

  ;

  function renderCartPrices(cart) {
    var currency = Avatar.theme.Currency;
    var discounts = cart.cart_level_discount_applications;
    var cartPriceBreakdown = document.querySelector(selectors.cartPriceBreakdown);
    var cartPriceSubtotalContainer = document.querySelector(selectors.cartPriceSubtotal);
    var cartDiscountsContainer = document.querySelector(selectors.cartDiscounts);
    var cartPriceLabel = document.querySelector(selectors.cartPriceLabel);
    var totalPrices = document.querySelectorAll(selectors.cartPrice);
    var cartTotal = document.querySelectorAll(selectors.cartTotal);
    totalPrices.forEach(function (price) {
      return price.textContent = currency.formatMoney(cart.total_price);
    });

    if (discounts.length > 0) {
      cartTotal.forEach(function (item) {
        item.classList.add(classes.textRight);
        item.classList.remove(classes.textCenter);
      });
      cartPriceBreakdown.classList.remove(classes.hidden);
      cartPriceLabel.classList.add(classes.widthLeft);
      cartPriceLabel.parentElement.classList.add(classes.flex);
      cartPriceLabel.parentElement.classList.remove(classes.textCenter);
      totalPrices.forEach(function (price) {
        if (price.previousSibling) {
          price.classList.add(classes.widthRight);
        }
      });
    } else {
      cartTotal.forEach(function (item) {
        item.classList.add(classes.textCenter);
        item.classList.remove(classes.textRight);
      });
      cartPriceBreakdown.classList.add(classes.hidden);
      cartPriceLabel.classList.remove(classes.widthLeft);
      cartPriceLabel.parentElement.classList.add(classes.textCenter);
      cartPriceLabel.parentElement.classList.remove(classes.flex);
      totalPrices.forEach(function (price) {
        if (price.previousSibling) {
          price.classList.remove(classes.widthRight);
        }
      });
    }

    if (cartPriceSubtotalContainer) {
      cartPriceSubtotalContainer.textContent = currency.formatMoney(cart.original_total_price);
    }

    cartDiscountsContainer.innerHTML = '';
    discounts.forEach(function (discount) {
      cartDiscountsContainer.innerHTML += "\n        <div class=\"tw-text-sm text-primary tw-flex\">\n          <span class=\"font-600 tw-w-2/3\">\n            <i class=\"fa fa-tags\"></i> ".concat(discount.title, "\n          </span>\n          <span class=\"ml-1 tw-w-1/3\">\n            -").concat(currency.formatMoney(discount.total_allocated_amount), "\n          </span>\n        </div>\n      ");
    });
  }
  /**
   * Updates the status of quantity elements
   *
   * @param {object} $quantityInput
   * @return {int}
   */


  function setQuantityControls(quantityInput) {
    var quantity = parseInt(quantityInput.value, 10);
    var max = parseInt(quantityInput.getAttribute('max'), 10);

    if (quantity <= 0) {
      quantityInput.previousElementSibling.setAttribute('disabled', true);
    } else {
      quantityInput.previousElementSibling.removeAttribute('disabled');
    }

    if (quantity >= max) {
      quantityInput.nextElementSibling.setAttribute('disabled', true);
    } else {
      quantityInput.nextElementSibling.removeAttribute('disabled');
    }

    return quantity;
  }

  function checkCookies() {
    if (!cache.container) return;
    if (Helpers.cookiesEnabled()) return;
    cache.container.classList.add(classes.noCookies);
  }

  init();
  return {
    init: init,
    initCartForm: initCartForm,
    checkCookies: checkCookies
  };
}();

register('cart-template', {
  onLoad: function onLoad() {
    Avatar.theme.Cart.init();
  }
});


    // If we reached this module (the entry point), it means no one accepted the HRM.
    // Let's reload the page then.
    if (module.hot) {
      module.hot.accept();
      // On first load, module.hot.data is undefined since it is not an update...
      // So if we do have a data object, it means we've been HMR'ed.
      if (module.hot.data) {
        window.__shopify_pipeline_should_reload__ = true;
      }
    }
  